import { call, put, select, takeEvery } from 'redux-saga/effects'

import {
  agentSourcedCreatorActionFailure,
  agentSourcedCreatorActionSuccess,
  rejectAgentSourcedCreator,
} from '@store/agentSourcedCreators/actions'
import { selectAgentSourcedCreators } from '@store/agentSourcedCreators/selectors'
import { selectAuthToken } from '@store/auth/selectors'
import { extractVerbatimErrorMessage } from '@store/discoveryRuns/api'
import { toast } from '@tribegroup'
import { networkRequest } from '@utils/networkRequest'

const creatorDisplayName = (creators: ReadonlyArray<any>, id: number): string => {
  const c = creators.find((x) => x.id === id)
  return (
    c?.creator_data?.fullname ?? c?.creator_data?.handle ?? c?.creator_data?.username ?? 'Creator'
  )
}

// Exported for direct unit testing, matching unshortlistCreator/shortlistCreator/undoCreatorAction.
export function* rejectCreatorSaga(action: ReturnType<typeof rejectAgentSourcedCreator>) {
  try {
    const { creatorId, href, method } = action.payload
    const token: string = yield select(selectAuthToken)
    const response: { id: number; status: string; links: unknown } = yield call(
      networkRequest,
      method,
      href,
      undefined,
      token,
    )
    yield put(
      agentSourcedCreatorActionSuccess({
        creatorId,
        status: 'rejected',
        updatedLinks: response.links as any,
      }),
    )
    const creators: ReadonlyArray<any> = yield select(selectAgentSourcedCreators)
    yield call(toast, `Rejected ${creatorDisplayName(creators, creatorId)}`)
  } catch (e: any) {
    const message = extractVerbatimErrorMessage(e)
    yield put(
      agentSourcedCreatorActionFailure({
        creatorId: action.payload.creatorId,
        error: message,
      }),
    )
    yield call(toast, `Reject failed: ${message}`)
  }
}

export default function* watchRejectAgentSourcedCreator() {
  yield takeEvery(rejectAgentSourcedCreator.type, rejectCreatorSaga)
}
